module.exports = __webpack_public_path__ + "static/img/draw-bg.e6a3801e.png";